module.exports = __webpack_public_path__ + "img/hojas-slider-01.75b504f4.svg";